export const geocodeAddress = async (
  query: string | { lat: string; lng: string }
) => {
  if (!window.google || !window.google.maps) {
    throw new Error('Google Maps API is not available.');
  }

  const geocoder = new window.google.maps.Geocoder();

  const geocode = async (
    params: google.maps.GeocoderRequest
  ): Promise<google.maps.GeocoderResult[]> => {
    return new Promise((resolve, reject) => {
      geocoder.geocode(params, (results, status) => {
        if (
          status === google.maps.GeocoderStatus.OK &&
          results &&
          results.length > 0
        ) {
          resolve(results);
        } else {
          reject(
            new Error(
              `Geocoding failed for query: ${JSON.stringify(
                params
              )}. Status: ${status}`
            )
          );
        }
      });
    });
  };

  const geocodeParams =
    typeof query === 'string'
      ? { address: query }
      : {
          location: { lat: parseFloat(query.lat), lng: parseFloat(query.lng) },
        };

  const results = await geocode(geocodeParams);

  const { geometry, formatted_address, address_components } = results[0];
  const { location } = geometry;

  const extractPostCode = (addressComponents: { types: string[] }[]) =>
    addressComponents.find((data) => data.types.includes('postal_code'));

  return {
    lat: location.lat(),
    lng: location.lng(),
    formatted: formatted_address,
    addressComponents: address_components,
    postCode: extractPostCode(address_components),
  };
};
